
import React, { useEffect, useMemo } from 'react';
import Chart from 'react-apexcharts';
import {
  Box,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import  {useState } from "react";
import { fetchDoctorDashboardData } from '../../../../redux/reducers/doctorDashboardSlice';
const months = ['MARCH', 'APRIL', 'MAY', 'JUNE'];
const getMonthLabels = () => months.map((m) => m.charAt(0) + m.slice(1).toLowerCase());

const Dashboard = () => {
  const dispatch = useDispatch();
  const { serviceTypeGrowth, loading } = useSelector((state) => state.doctorDashboard);
  const [view, setView] = useState('month');
  const [chartSeries, setChartSeries] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    dispatch(fetchDoctorDashboardData());
  }, [dispatch]);

  const prepareChartData = useMemo(() => {
    if (!serviceTypeGrowth || loading) return [];

    const result = [];

    if (view === 'month') {
      const monthLabels = getMonthLabels();
      setCategories(monthLabels);
      Object.entries(serviceTypeGrowth).forEach(([type, val]) => {
        const data = months.map((m) => val.monthlyCounts?.[m] || 0);
        result.push({ name: type, data });
      });
    } else if (view === 'week') {
      const days = Array.from({ length: 31 }, (_, i) => `${i + 1}`);
      setCategories(days);
      Object.entries(serviceTypeGrowth).forEach(([type, val]) => {
        const weekCounts = val.dailyCountsForCurrentMonth || {};
        const data = days.map((d) => weekCounts[d] || 0);
        result.push({ name: type, data });
      });
    } else if (view === 'year') {
      setCategories(['2025']);
      Object.entries(serviceTypeGrowth).forEach(([type, val]) => {
        result.push({ name: type, data: [val.yearlyCount || 0] });
      });
    }

    return result;
  }, [serviceTypeGrowth, view, loading]);

  useEffect(() => {
    setChartSeries(prepareChartData);
  }, [prepareChartData]);

  const chartOptions = {
    chart: {
      type: 'line',
      toolbar: { show: false },
    },
    stroke: {
      curve: 'smooth',
      width: 2,
    },
    xaxis: {
      categories: categories,
    },
    legend: {
      position: 'right',
      labels: { colors: '#111' },
    },
    colors: ['#1e3a8a', '#38bdf8', '#22c55e', '#eab308', '#ef4444', '#a855f7', '#14b8a6'],
    grid: {
      borderColor: '#e0e0e0',
    },
  };

  return (
    <Box p={4} bgcolor="#f9fafb">
      <Box display="flex" justifyContent="flex-end" alignItems="center" mb={2}>
        {/* <ToggleButtonGroup
          value={view}
          exclusive
          onChange={(_, val) => val && setView(val)}
          size="small"
          sx={{
            backgroundColor: '#f0f2f5',
            borderRadius: '12px',
            '& .Mui-selected': {
                          borderRadius: '7px',

            backgroundColor: '#005EB8',
              color: '#fff',
            },
          }}
        >
          <ToggleButton value="week">Week</ToggleButton>
          <ToggleButton value="month">Month</ToggleButton>
          <ToggleButton value="year">Year</ToggleButton>
        </ToggleButtonGroup> */}
        <ToggleButtonGroup
  value={view}
  exclusive
  onChange={(_, val) => val && setView(val)}
  size="small"
  sx={{
    backgroundColor: '#f0f2f5',
    borderRadius: '12px',

    // Apply styles to each grouped toggle button
    '& .MuiToggleButtonGroup-grouped': {
      borderRadius: '7px',
      borderColor: 'transparent',
      color: '#333',

      // Only apply to selected button
      '&.Mui-selected': {
        backgroundColor: '#005EB8',
        color: '#fff',
      },
    },
  }}
>
  <ToggleButton value="week">Week</ToggleButton>
  <ToggleButton value="month">Month</ToggleButton>
  <ToggleButton value="year">Year</ToggleButton>
</ToggleButtonGroup>
      </Box>

      <Box display="flex" gap={3}>
        <Box flex={1} bgcolor="#fff" p={3} borderRadius="16px" boxShadow={2}>
          <Typography fontWeight={600} mb={1}>
            Service Type Growth ({view.charAt(0).toUpperCase() + view.slice(1)})
          </Typography>

          {chartSeries.length > 0 ? (
            <Chart options={chartOptions} series={chartSeries} type="line" height={320} />
          ) : (
            <Typography>Loading chart...</Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default Dashboard;
